import React from 'react';
import { ListboxOption as ListboxOptionStyle } from './styles';
import forwardRef from '../../private/forwardRef';
import { ListboxOptionProps } from './listbox-option.types';

// The public props stay un-prefixed; the styled component underneath takes
// transient ones so they are not forwarded to the <li>.
const ListboxOption = forwardRef<ListboxOptionProps, 'li'>(
    ({ sizeVariant, isActive, ...props }, externalRef) => (
        <ListboxOptionStyle
            ref={externalRef}
            $sizeVariant={sizeVariant}
            $isActive={isActive}
            {...props}
        />
    ),
);

ListboxOption.displayName = 'ListboxOption';

export default ListboxOption;
